import type { ProjectsDataSlice } from './projects.type'

export const projectsInitialState: ProjectsDataSlice = {
  projects: [],
  allProjects: [],
  userProjectsFetched: false,
  currentProject: null,
  isResolvingWorkspaceProject: false,
  loading: false,
  error: null,
}
